import { FormValidator, isValidCep } from '~/modules';
import { isBrazilianState } from '~/utils';

export const validationSchema = () =>
  FormValidator.object().shape({
    cep: FormValidator.string()
      .required('Digite seu CEP')
      .test('cep', 'CEP inválido', isValidCep),
    street: FormValidator.string().required('Digite o nome da rua'),
    neighborhood: FormValidator.string().required('Digite o nome do bairro'),
    city: FormValidator.string().required('Digite o nome da cidade'),
    uf: FormValidator.string()
      .required('Digite a sigla do estado')
      .test('uf', 'Sigla do estado inválida', (value: string | undefined) =>
        isBrazilianState(value),
      ),
    number: FormValidator.string().required('Digite o número da residência'),
  });

export type OnboardingAddressFormValues = AddressData;

export const initialValues: OnboardingAddressFormValues = {
  cep: '',
  street: '',
  neighborhood: '',
  city: '',
  uf: '',
  complement: '',
  number: '',
};
